/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2025-02-04",
    versionChannel: "nightly",
    buildDate: "2025-02-04T00:06:20.581Z",
    commitHash: "0821c11b11b232cf591f4ad5555692ac2a18b435",
};
